export function initPropertyList(settings)
{
    if (!window.jQuery) {
        return;
    }

    settings = settings || {};

    var $ = window.jQuery;
    var $properties = $('#properties');

    if (!$properties.length || !$.fn.jplist) {
        return;
    }

    $properties.jplist({
        debug: true,
        itemsBox: '.propertyList',
        itemPath: '.propertyItem',
        panelPath: '.propertyPanel',
        noResults: '.jplist-no-results',
        storage: typeof settings.storage === 'undefined' ? 'cookies' : settings.storage,
        storageName: settings.storageName || 'jplist-div-layout',
        cookiesExpiration: -1,
        redrawCallback: function () {
            if ($('.jplist-label.jplist-empty').length) {
                $('.pagination-all').hide();
            } else {
                $('.pagination-all').show();
            }
        }
    });

    if (!$('.jplist-select.listPerPage').length) {
        return;
    }

    if ($('.jplist-select.listPerPage').val() === '6 per page') {
        $('.all-view').show();
        $('.four-view').hide();
    } else {
        $('.all-view').show();
        $('.four-view').hide();
        $('.jplist-select.listPerPage option:eq(0)').prop('selected', true).change();
    }
}

function scrollTopProperties()
{
    if (!window.jQuery) {
        return;
    }

    var $ = window.jQuery;

    if (!$('#properties').length) {
        return;
    }

    $('html, body').animate({
        scrollTop: $('#properties').offset().top - 120
    }, 0);
}

export function installPropertyListPaginationGlobals()
{
    if (!window.jQuery) {
        return;
    }

    var $ = window.jQuery;

    window.viewAll = function ()
    {
        $('.four-view').show();
        $('.all-view').hide();
        $('.jplist-select option:eq(1)').prop('selected', true).change();
        scrollTopProperties();
    };

    window.viewSix = function ()
    {
        $('.all-view').show();
        $('.four-view').hide();
        $('.jplist-select.listPerPage option:eq(0)').prop('selected', true).change();
        scrollTopProperties();
    };

    window.listPrevClick = function ()
    {
        $('.jplist-prev').click();
        scrollTopProperties();
    };

    window.listNextClick = function ()
    {
        $('.jplist-next').click();
        scrollTopProperties();
    };
}
